export default "https://cdn-static.gokick.com/assets/21dc595b281e80327dab5b97c944977d2420b47e/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";